import React from 'react';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import { AccessBadgeTitle, AccessBadgeRoot } from './styles';
import { AccessBadgeProps } from './types';

export function AccessGrantedBadge({ fontSize = 16 }: AccessBadgeProps) {
  return (
    <AccessBadgeRoot style={{ fontSize }}>
      <PlayArrowIcon fontSize="inherit" />
      <AccessBadgeTitle>Access granted</AccessBadgeTitle>
    </AccessBadgeRoot>
  );
}
